import { render, staticRenderFns } from "./facedetail.vue?vue&type=template&id=c1e4b3f4&scoped=true&"
import script from "./facedetail.vue?vue&type=script&lang=js&"
export * from "./facedetail.vue?vue&type=script&lang=js&"
import style0 from "./facedetail.vue?vue&type=style&index=0&id=c1e4b3f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e4b3f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\zy_frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c1e4b3f4')) {
      api.createRecord('c1e4b3f4', component.options)
    } else {
      api.reload('c1e4b3f4', component.options)
    }
    module.hot.accept("./facedetail.vue?vue&type=template&id=c1e4b3f4&scoped=true&", function () {
      api.rerender('c1e4b3f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/report/components/facedetail.vue"
export default component.exports